import type { ReactNode } from 'react'
import { AlertCircle, CheckCircle2, Info } from 'lucide-react'

import { cn } from '@/lib/cn'

type Variant = 'error' | 'info' | 'success'

interface AlertProps {
  variant?: Variant
  children: ReactNode
  className?: string
}

const styles: Record<Variant, { wrap: string; icon: typeof AlertCircle }> = {
  error: {
    wrap: 'border-danger/30 bg-danger/5 text-danger',
    icon: AlertCircle,
  },
  info: {
    wrap: 'border-border-subtle bg-bg-surface text-text-primary',
    icon: Info,
  },
  success: {
    wrap: 'border-success/30 bg-success/5 text-success',
    icon: CheckCircle2,
  },
}

export default function Alert({ variant = 'info', children, className }: AlertProps) {
  const { wrap, icon: Icon } = styles[variant]
  return (
    <div
      role="alert"
      className={cn(
        'flex items-start gap-2 rounded-card border px-3 py-2.5 text-sm',
        wrap,
        className,
      )}
    >
      <Icon className="mt-0.5 h-4 w-4 flex-shrink-0" aria-hidden />
      <div className="flex-1">{children}</div>
    </div>
  )
}
